import { Component, Injectable, OnInit } from '@angular/core';
import { UrlService } from '../../../shared/services/url.service';
import { ConfigurationService } from '../../services/configuration.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { Filter } from '../../model/Filter';
import { ValueItem } from '../../model/ValueItem';
import { ApplicationItem } from '../../model/ApplicationItem';
import { MatDialog } from '@angular/material';
import { ConfirmationModalComponent } from './confirmationModal.component';
import { ConfigurationEditorModalComponent } from './configurationEditorModal.component';

@Component({
  selector: 'app-configurationFilter',
  templateUrl: '../templates/configurationFilter.component.html'
})

@Injectable()
export class ConfigurationFilterComponent implements OnInit {
  DashboardUrl: string;
  isFiltering = false;
  Applications: ApplicationItem[];
  Values: ValueItem[] = [];
  CurrentKey = '';
  CurrentApplicationId = '';
  CurrentValue = '';

  constructor(private urlService: UrlService,
    private configurationService: ConfigurationService,
    private alertService: AlertService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.initFilter();
  }

  private initFilter() {
    this.configurationService.GetApplications().subscribe(applications => {
      this.Applications = applications;
    });
  }

  selectApplication(value: ApplicationItem): void {
    this.CurrentApplicationId = value ? value.Id : '';
  }

  Filter(): void {
    this.alertService.removeAll();
    if (!this.CurrentKey && !this.CurrentApplicationId && !this.CurrentValue) {
      this.alertService.add('warning', 'Empty filters. Please check it!');
      return;
    }
    this.isFiltering = true;
    this.Values = [];
    const filter = {
      key: this.CurrentKey,
      applicationId: this.CurrentApplicationId,
      value: this.CurrentValue
    } as Filter;
    this.configurationService.GetValues(filter).subscribe(values => {
      this.isFiltering = false;
      this.Values = values;
    },
      err => {
        this.isFiltering = false;
        this.alertService.add('warning', 'Not Fount: ' + err);
      });
  }

  DeleteValue(value: ValueItem) {
    this.dialog.open(ConfirmationModalComponent, {
      hasBackdrop: true,
      backdropClass: 'fxstreet-modal-backdrop',
      panelClass: 'fxstreet-preview-dialog-panel',
      data: {
        Key: value.Key,
        Operation: 'Delete'
      }
    }).afterClosed().subscribe(shouldDelete => {
      if (shouldDelete) {
        this.configurationService.DeleteValue(value)
          .subscribe(() => this.DeleteSuccess(value), err => this.DeleteError(err));
      }
    });
  }

  EditValue(value: ValueItem) {
    this.dialog.open(ConfigurationEditorModalComponent, {
      hasBackdrop: true,
      backdropClass: 'fxstreet-modal-backdrop',
      panelClass: 'fxstreet-config-editor-modal',
      data: {
        text: value.Value,
        configKey: value.Key,
        appName: value.Application.Name
      }
    }).afterClosed().subscribe(data => {
      if (data && data.shouldUpdate) {
        value.Value = data.configValue;
        this.configurationService.EditOrCreateValue(value)
          .subscribe(() => this.UpdateSuccess(value), err => this.UpdateError(err));
      }
    });
  }

  private DeleteError (err: any) {
    this.alertService.add('danger', 'Delete Value error: ' + err);
  }

  private DeleteSuccess(value: ValueItem) {
    this.alertService.add('success', `Value "${value.Key}" from App "${value.Application.Name}" has been deleted.`);
    const index = this.Values.findIndex(b => b.Key === value.Key && b.Application.Id === value.Application.Id);
    this.Values.splice(index, 1);
  }

  private UpdateError(err: any) {
    this.alertService.add('danger', 'Update Value error: ' + err);
  }

  private UpdateSuccess(value: ValueItem) {
    this.alertService.add('success', `Value "${value.Key}" from App "${value.Application.Name}" has been saved.`);
    const index = this.Values.findIndex(b => b.Key === value.Key && b.Application.Id === value.Application.Id);
    this.Values[index] = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configurationFilter.component.ts